import { content } from '../content';
import type { RouteOption } from '../core/types';

export const ACT_DETAILS: Record<number, { numeral: string; name: string; note: string }> = {
  1: { numeral: 'I', name: 'Bellrose Extraction Line', note: 'Recover the camp. Keep the Genesis cylinders sealed and the evacuation route dry.' },
  2: { numeral: 'II', name: 'The Sealed Research Station', note: 'Reach the remaining staff and isolate the failing refinery before its cooling gives out.' },
  3: { numeral: 'III', name: 'The Counterweight Vault', note: 'Stop the experimental intake. Dimiti is beyond this conflict; the machinery is not.' },
};

// Historical saves contain old labels. Derive presentation from stable IDs without
// mutating the save, allocating IDs, or consuming the deterministic RNG.
export function routePresentation(option: RouteOption): { label: string; description: string } {
  if (option.encounterId && content.encounters[option.encounterId]) {
    const encounter = content.encounters[option.encounterId]!;
    return { label: encounter.name, description: option.kind === 'boss'
      ? 'The line stays closed until this guardian is defeated.'
      : option.kind === 'elite' ? 'A dangerous encounter guarding recovered field equipment.'
      : 'Clear the route for Iron and a new technique.' };
  }
  if (option.eventId && content.events[option.eventId]) {
    return { label: content.events[option.eventId]!.title, description: 'A choice off the supply line. Inspect the costs before committing.' };
  }
  if (option.kind === 'trader') return { label: 'Field Quartermaster', description: 'Trade Iron for cards, relics, repairs, or a lighter deck.' };
  if (option.kind === 'forge') return { label: 'Field Workshop', description: 'Heal, upgrade one card, or repair all Gear.' };
  return { label: 'Unknown outpost', description: 'This route is unavailable.' };
}

export const WORLD_URL = 'https://www.worldanvil.com/w/cathedris-stormbril';
